import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import PanelTitle from "../global/PanelTitle";
import OnlineAccessForm from "./OnlineAccessForm";
import { ModalContext } from "../../context/ModalContext";
import { OnlineAccessesContext } from "../../context/OnlineAccessesContext";
import Pagination from "../global/Pagination";

const PAGE_SIZE = 32;

const OnlineTable = ({ customer_id }) => {
  const [page, setPage] = useState(1);

  const { modalComponent } = useContext(ModalContext);
  const { total, online_accesses, getOnlineAccesses } = useContext(
    OnlineAccessesContext
  );

  useEffect(() => {
    const params = { page };
    if (customer_id) params.customer_id = customer_id;
    getOnlineAccesses(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, customer_id]);

  const editAcceso = (access) => {
    modalComponent(
      "Editar Accesso",
      <OnlineAccessForm online_access={access} />
    );
  };

  const handleCreateAccess = () => {
    const currentDate = moment().utc(true).startOf("day");
    const expirationDate = currentDate.clone().add(30, "days").endOf("day");

    modalComponent(
      "Editar Accesso",
      <OnlineAccessForm
        online_access={{
          customer_id,
          status: "active",
          start_date: currentDate.format(),
          expiration_date: expirationDate.format(),
        }}
      />
    );
  };

  const renderAccesos = () => {
    if (!Array.isArray(online_accesses)) {
      return <div className="spinner-border" role="status" />;
    }
    return (
      <div className="table-responsive">
        <table className="table border">
          <thead className="bg-light border bold small">
            <tr>
              <td>#Acceso</td>
              <td>#Compra</td>
              <td>#Cargo</td>
              <td>Estatus</td>
              <td>Fecha de Inicio</td>
              <td>Fecha de Expiración</td>
              <td>Acciones</td>
            </tr>
          </thead>
          <tbody>
            {online_accesses.map((access) => {
              const startDate = moment(access.start_date)
                .utc()
                .format("DD MMM YYYY HH:mm:ss");
              const expirationDate = moment(access.expiration_date)
                .utc()
                .format("DD MMM YYYY HH:mm:ss");

              const accessStatuses = {
                revoked: "Revocado",
                paused: "Pausado",
                active: "Activo",
              };

              const purchase = access.purchase_id ? access.purchase_id : "N/A";
              const invoice = access.invoice_id ? access.invoice_id : "N/A";

              return (
                <tr key={access.online_access_id} className="">
                  <td>{access.online_access_id}</td>
                  <td>{purchase}</td>
                  <td>{invoice}</td>
                  <td>{accessStatuses[access.status]}</td>
                  <td>{startDate}</td>
                  <td>{expirationDate}</td>
                  <td>
                    <button
                      onClick={() => editAcceso(access)}
                      className="btn btn-sm btn-outline-dark"
                    >
                      <i className="fa fa-edit" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="card no-scale my-3">
      <PanelTitle title="Accesos" onClick={handleCreateAccess} />
      {renderAccesos()}
      {total > PAGE_SIZE && (
        <Pagination
          totalItems={total}
          currentPage={page}
          itemsPerPage={PAGE_SIZE}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default OnlineTable;
